// uiSlice.js
import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  isLocationModalOpen: false,
  isShareModalOpen: false,
  alertModal: {
    visible: false,
    title: "",
    message: "",
    type: "info",
    primaryButtonText: "OK",
    secondaryButtonText: null,
    autoClose: false,
    autoCloseDuration: 3000,
  },
};

const uiSlice = createSlice({
  name: "ui",
  initialState,
  reducers: {
    openLocationModal: (state) => {
      state.isLocationModalOpen = true;
    },
    closeLocationModal: (state) => {
      state.isLocationModalOpen = false;
    },
    setShareModalOpen: (state, action) => {
      state.isShareModalOpen = !!action.payload;
    },
    showAlert: (state, action) => {
      state.alertModal = {
        ...initialState.alertModal,
        ...action.payload,
        visible: true,
      };
    },
    hideAlert: (state) => {
      state.alertModal.visible = false;
    },
  },
});

export const { 
  openLocationModal, 
  closeLocationModal, 
  setShareModalOpen, 
  showAlert, 
  hideAlert 
} = uiSlice.actions;

export const selectIsLocationModalOpen = (state) => state.ui.isLocationModalOpen;
export const selectIsShareModalOpen = (state) => state.ui.isShareModalOpen;
export const selectAlertModal = (state) => state.ui.alertModal;

export default uiSlice.reducer;
